import { Component } from '@theme/component';

/**
 * Roberts Jewelers — Ring size selector.
 *
 * Keeps the "Ring Size: X" label in sync with the <select> (a line-item
 * property submitted with the add-to-cart form).
 *
 * @typedef {object} Refs
 * @property {HTMLSelectElement} select
 * @property {HTMLElement} value
 *
 * @extends {Component<Refs>}
 */
class RobertsRingSize extends Component {
  requiredRefs = ['select'];

  updateValue() {
    const { select, value } = this.refs;
    if (select instanceof HTMLSelectElement && value) {
      value.textContent = select.value;
    }
  }
}

if (!customElements.get('roberts-ring-size')) {
  customElements.define('roberts-ring-size', RobertsRingSize);
}
